(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["beardofgod-butter-balm-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', function (event) {
    const guide = event.target;
    if (!(guide instanceof HTMLDetailsElement) || !guide.matches('[data-bog-butter-balm]') || !guide.open) return;
    const slot = guide.querySelector('[data-bog-instagram-slot]');
    const template = guide.querySelector('[data-bog-instagram-template]');
    if (!slot || !template) return;
    if (!slot.childElementCount) slot.appendChild(template.content.cloneNode(true));
    const processEmbeds = function () {
      if (window.instgrm && window.instgrm.Embeds) window.instgrm.Embeds.process();
    };
    let script = document.querySelector('script[src*="instagram.com/embed.js"]');
    if (!script) {
      script = document.createElement('script');
      script.src = 'https://www.instagram.com/embed.js';
      script.async = true;
      script.addEventListener('load', processEmbeds, { once: true });
      document.head.appendChild(script);
    } else {
      script.addEventListener('load', processEmbeds, { once: true });
      processEmbeds();
    }
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["beardofgod-scent-guide"] && !Shopify.designMode) return;
  try {
    (() => {
  const pending = new WeakMap();
  document.addEventListener('variant:changed', async (event) => {
    const scope = event.target.closest('[data-section-type="product"]') || event.target.closest('.Product') || event.target;
    const guide = scope.querySelector('[data-bog-scent-guide]');
    if (!guide || !guide.dataset.scentPosition || guide.dataset.scentPosition === '0') return;
    const variant = event.detail && event.detail.variant;
    const products = scope.querySelector('[data-bog-fragrance-products]');
    const previous = pending.get(guide);
    if (previous) previous.abort();
    if (!variant) {
      guide.hidden = true;
      if (products) products.hidden = true;
      return;
    }
    const index = Number(guide.dataset.scentPosition) - 1;
    const previousVariant = event.detail.previousVariant;
    if (previousVariant && variant.options[index] === previousVariant.options[index] && !guide.hidden) return;
    const controller = new AbortController();
    pending.set(guide, controller);
    guide.hidden = true;
    if (products) products.hidden = true;
    const url = new URL(guide.dataset.productUrl, window.location.origin);
    url.searchParams.set('variant', variant.id);
    url.searchParams.set('section_id', guide.dataset.sectionId);
    try {
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error('Fragrance section unavailable');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (controller.signal.aborted) return;
      const refreshedGuide = parsed.querySelector('[data-bog-scent-guide]');
      const refreshedProducts = parsed.querySelector('[data-bog-fragrance-products]');
      if (refreshedGuide) {
        guide.innerHTML = refreshedGuide.innerHTML;
        guide.dataset.scentKey = refreshedGuide.dataset.scentKey;
        guide.hidden = refreshedGuide.hidden;
      }
      if (products && refreshedProducts) {
        products.innerHTML = refreshedProducts.innerHTML;
        products.dataset.scentKey = refreshedProducts.dataset.scentKey;
        products.hidden = refreshedProducts.hidden;
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        guide.hidden = true;
        if (products) products.hidden = true;
      }
    } finally {
      if (pending.get(guide) === controller) pending.delete(guide);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
